export function mapSupplierProductToInternal(product, options = {}) {
  const {
    includeFabricInText = false,
    defaultProductPrice = '0',
    defaultRetailPrice = '0',
    defaultProductPriceAdjust = '0',
    defaultProfitPercentage = '0',
    defaultWeightInGram = 0,
    timeStart = null,
    supplierID = 40
  } = options

  const elementTitle = product.productName || ''
  const baseText = product.productText || ''
  const elementContent = includeFabricInText && product.productFabrics ? `${baseText}\n\nMatriale: ${product.productFabrics}` : baseText

  const internalVariations = (product.variations || []).flatMap(variation => {
    const colorName = variation.itemColorName || variation.itemColorCode || ''
    return (variation.skus || []).map(sku => {
      const title = `${colorName}/${sku.webtext || sku.size || ''}`.trim().replace(/\/\s*$/, '')
      return {
        variationTitle: title,
        variationUID: sku.sku,
        variationStock: 0,
        limitedStock: sku.availabilityRegional === null || sku.availabilityRegional < 40 ? true : false,
        externalStock: false,
        subscriptions: [],
        variationSize: sku.webtext || sku.size || '',
        variationColor: colorName || '',
        allowPreorder: false,
        preorderStock: null,
        poolOrder: 0,
        EAN: sku.eanCode || ''
      }
    })
  })

  return {
    elementTitle,
    elementContent,
    productPrice: String(defaultProductPrice),
    retailPrice: product.price || String(defaultRetailPrice),
    productPriceAdjust: String(defaultProductPriceAdjust),
    profitPercentage: String(defaultProfitPercentage),
    productStatus: 'AVAILABLE',
    productWeightInGram: Number(defaultWeightInGram) || 0,
    timeStart,
    timeEnd: null,
    stockAvailableDate: null,
    productStockLimit: 0,
    minCount: 1,
    categories: [],
    catalogs: [
      {
        CatalogID: '',
        productPrice: '',
        productPriceAdjust: '',
        sticky: false,
        stickyDuration: 1,
        enableDiscount: false,
        discountPrice: null,
        basisPrice: null
      }
    ],
    variations: internalVariations,
    manufacturer: product.productBrand || '',
    SupplierID: supplierID,
    dropshipFreightPrice: null,
    enabledropship: 0,
    translations: [],
    images: [],
    video: ''
  }
}
